import React, { useEffect, useState } from "react";

import { db } from "../lib/firebaseCompat";

import { useParams } from "react-router-dom";

import EstimateForm from "./EstimateForm";
import LegacyWarning from "../components/EstimateForm/LegacyWarning";
import Layout from "../components/shared/Layout";
import Loading from "../components/shared/Loading";

import { useScrollToTop } from "../hooks/use-scroll-to-top";
import { useOrganization } from "../hooks/useOrganization";

const defaultEstimate = {
  industryName: "",
  notes: "",
  assets: [],
  newAsset: {
    name: "",
    cost: 0,
  },
};

const initialState = {
  loaded: false,
  estimate: defaultEstimate,
};

export default function EditEstimate() {
  useScrollToTop();

  const { id } = useParams();
  const {current: organization} = useOrganization();
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!organization.id) {
      return;
    }
    const ref = db
      .collection("organizations")
      .doc(organization.id)
      .collection("estimates")
      .doc(id);

    (async () => {
      const doc = await ref.get();
      const estimate = { id: doc.id, ...doc.data() };
      setState({ loaded: true, estimate });
    })();
  }, [db, organization, id]);

  const assets = [];

  const { loaded, estimate } = state;
  const initialEstimate = { assets, ...estimate };
  // const initialEstimate = { ...defaultEstimate, ...estimate };

  // const { all = [] } = data;
  // const template = all.find(({ estimate }) => Number(id) === estimate.id) || {};
  //
  // const assets = (template.assets || []).map(({ name, cost }) => {
  //   return { name, cost };
  // });
  //
  // const estimate = { assets, ...template.estimate };
  // const initialEstimate = { ...defaultEstimate, ...estimate };

  return (
    <Layout>
      {!loaded ? (
        <Loading />
      ) : (
        <>
          <LegacyWarning visible={estimate.legacy} />
          <EstimateForm initialEstimate={initialEstimate} docId={id} />
        </>
      )}
    </Layout>
  );
}
